import moment from 'moment'

const urlParser = document.createElement('a')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function prettyNumber (value) {
  if (value === 'ONE') {
    return 'One'
  } else if (value === 'MORE_THAN_ONE') {
    return 'More than one'
  } else {
    return ''
  }
}

export function prettyArray (array) {
  if (array === null) return null
  else {
    let lastIndex = array.length - 1
    return array.map((value, ind) => {
      if (ind === lastIndex) return `${value}`
      else return `${value},`
    })
  }
}

export function prettyDate (value) {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  }
}

export function age (value) {
  if (value) {
    return moment().diff(moment(value), 'years')
  }
}

export function prettyDateTime (value) {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm')
  }
}

export function prettyTime (value) {
  if (value) {
    return moment(value).format('HH:mm')
  }
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}



// WEBPACK FOOTER //
// ./src/filters/index.js